import { StyledQRCode } from "@components/StyledQRCode";
import { cn } from "utils";

interface EdgenAppQRCodeProps {
  foregroundColor?: string;
  backgroundColor?: string;
  size?: number;
  className?: string;
  margin?: number;
}

export const EdgenAppQRCode = ({
  foregroundColor,
  backgroundColor,
  size,
  className,
  margin,
}: EdgenAppQRCodeProps) => {
  // 生成指向重定向页面的二维码
  // 重定向页面会根据扫码设备的类型自动跳转到对应的链接
  const baseUrl = typeof window !== "undefined" ? window.location.origin : "";
  const redirectUrl = `${baseUrl}/download-url`;
  // const redirectUrl = "https://edgen.go.link/cNppo"; // adjust deep link url

  return (
    <StyledQRCode
      value={redirectUrl}
      size={size || 240}
      margin={margin || 3}
      foregroundColor={foregroundColor || "#FFFFFF"}
      backgroundColor={backgroundColor || "#1a1a1a"}
      errorCorrectionLevel="H"
      className={cn(
        "rounded-[24px] bg-background_solid_neutral_secondary",
        className,
      )}
    />
  );
};
